import { useCallback, useState } from 'react';
import { SizeOptionParams } from '../app/pages/ValidationsPage/components/modules/AssetModel/hook';
import { getAssetModel } from 'services/asset';
import { AssetModel, ParamGetAssetModels } from '../app/pages/ValidationsPage/type';
import { Model } from 'types/room';
import { unionBy } from 'lodash';

type ModelEntities = Record<string, { name: string; id: number }>;

export const useFetchAssetModel = (model?: Model) => {
  const [optionModel, setOptionModel] = useState<{ label: string; value: string }[]>([]);
  const [hasMoreOptionModel, setHasMoreOptionModel] = useState<boolean>(false);
  const [pageOptionModel, setPageOptionModel] = useState<number>(1);
  const [isLoadingMore, setIsLoadingMore] = useState<boolean>(false);
  const [modelEntities, setModelEntities] = useState<ModelEntities>({});

  //START func get option model

  const getOptionModel = useCallback(
    async (params: Partial<ParamGetAssetModels>) => {
      const data = (await getAssetModel(params)) as { models: AssetModel[]; total: number };
      const modelEntities: ModelEntities = {};
      const dataConvert = data?.models?.map((item) => {
        modelEntities[item.id] = item.manufacturer;
        return {
          value: item.id.toString(),
          label: item.name
        };
      });

      if (!modelEntities?.[model?.id || 0] && model) {
        dataConvert.push({ label: model?.name, value: model?.id?.toString() });
      }
      dataConvert.unshift({ label: 'Other', value: 'OTHER' });
      setModelEntities(modelEntities);
      setOptionModel(dataConvert);
      if (data.total <= SizeOptionParams) {
        setHasMoreOptionModel(false);
        return;
      }
      setHasMoreOptionModel(true);
      setPageOptionModel(2);
    },
    [model]
  );

  const handleFetchMoreOptionModel = useCallback(async () => {
    if (!hasMoreOptionModel || isLoadingMore) return;
    try {
      const paramsConvert = {
        page: pageOptionModel,
        size: SizeOptionParams
      };
      setIsLoadingMore(true);
      const data = (await getAssetModel(paramsConvert)) as { models: AssetModel[]; total: number };
      const dataConvert = data?.models?.map((item) => ({
        value: item.id.toString(),
        label: item.name
      }));
      setOptionModel(unionBy([...optionModel, ...dataConvert], 'value'));
      if (data.total <= SizeOptionParams * pageOptionModel) {
        setHasMoreOptionModel(false);
        return;
      }
      setHasMoreOptionModel(true);
      setPageOptionModel(pageOptionModel + 1);
    } finally {
      setIsLoadingMore(false);
    }
  }, [hasMoreOptionModel, isLoadingMore, pageOptionModel, optionModel]);

  return {
    getOptionModel,
    optionModel,
    hasMoreOptionModel,
    handleFetchMoreOptionModel,
    isLoadingMore,
    setPageOptionModel,
    modelEntities
  };
};
